<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { TwistBox } from '@twist/core';
  import { jobsFiltersStore } from '$lib/stores/Careers/jobFiltersStore';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import BlockButton from '$components/Button/BlockButton.svelte';

  const dispatch = createEventDispatcher();

  function handleResetFilters() {
    jobsFiltersStore.reset();

    dispatch('filters-change', $jobsFiltersStore);
  }

  let hasActiveFilters = $state(false);

  jobsFiltersStore.subscribe((store) => {
    const { query, isRemote, locations, teams, employeeTypes, businessUnits } = store;
    hasActiveFilters =
      query.length > 0 ||
      isRemote ||
      locations.length > 0 ||
      teams.length > 0 ||
      employeeTypes.length > 0 ||
      businessUnits.length > 0;
  });
</script>

<TwistBox
  marginTop={toFluidVarInput(45, 0)}
  marginBottom={toFluidVarInput(30, 0)}
  marginRight={toFluidVarInput(-15, -15)}
>
  <BlockButton variant="ghost" onclick={handleResetFilters} disabled={!hasActiveFilters}>
    Reset filters
  </BlockButton>
</TwistBox>
